import { useAttachmentStore } from "@/state/stores";
import { ScrollArea, Scrollbar, Viewport } from "@radix-ui/react-scroll-area";
import { AlertTriangle, Paperclip } from "lucide-react";
import { useState } from "react";
import type { AttachmentFile } from "../../../../state/stores/types";
import { AttachmentButton } from "./AttachmentButton";
import { UserAttachmentPreviewModal } from "./UserAttachmentPreviewModal";

export function UserAttachmentsSection() {
  const files = useAttachmentStore((state) => state.files);
  const removeFile = useAttachmentStore((state) => state.removeFile);
  const [previewFile, setPreviewFile] = useState<AttachmentFile | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handleFileClick = (file: AttachmentFile) => {
    setPreviewFile(file);
    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
    setPreviewFile(null);
  };

  if (files.length === 0) {
    return null;
  }

  return (
    <>
      <ScrollArea>
        <Viewport className="-mx-3 px-3">
          <div className="flex gap-1">
            {files.map((file) => (
              <AttachmentButton
                key={file.id}
                name={file.name}
                size={file.size}
                onClick={() => handleFileClick(file)}
                onRemove={() => removeFile(file.id)}
                variant="removable"
              />
            ))}
          </div>
        </Viewport>
        <Scrollbar orientation="horizontal" />
      </ScrollArea>

      <UserAttachmentPreviewModal
        attachment={previewFile}
        isOpen={isPreviewOpen}
        onClose={handleClosePreview}
      />
    </>
  );
}

export function UserAttachmentsDndOverlay() {
  const isDragging = useAttachmentStore(({ isDragging }) => isDragging);
  const hasUnsupportedFiles = useAttachmentStore(
    ({ hasUnsupportedFiles }) => hasUnsupportedFiles,
  );

  if (!isDragging) {
    return null;
  }

  return (
    <div className="absolute -inset-px bg-muted border border-dashed border-border rounded-[inherit] flex items-center justify-center gap-2 z-10 animate-fadeIn duration-150">
      {hasUnsupportedFiles ? (
        <AlertTriangle className="h-4 w-4" />
      ) : (
        <Paperclip className="h-4 w-4" />
      )}
      <p className="text-sm font-medium text-foreground">
        {hasUnsupportedFiles
          ? "Some files are not supported. Only text-based files are accepted."
          : "Drop files here to add as attachments"}
      </p>
    </div>
  );
}
